import React from 'react';
import { RangeModifier } from 'react-day-picker';
import { ReactSVG } from 'react-svg';
import useDropdown from 'use-dropdown';
import classNames from 'classnames';
import ArrowIcon from 'Assets/images/icons/select-arrow-icon.svg';
import DatePickerIcon from 'Assets/images/icons/datepicker.svg';
import Calendar from './components/DayPicker';
import { CalendarProps } from './components/DayPicker/Calendar';

export interface UIDatePickerProps extends CalendarProps {
  position?: 'right' | 'left';
  placeholder?: string;
  disabled?: boolean;
}

const isDate = (date: RangeModifier | Date): date is Date => {
  return (date as Date).getTime !== undefined;
};

const UIDatePicker = ({
  position = 'left',
  value,
  placeholder,
  disabled,
  ...restProps
}: UIDatePickerProps) => {
  const [containerRef, isOpen, open, close] = useDropdown();

  const handleOpenClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (isOpen) {
      close(e);
    } else {
      open(e);
    }
  };

  const currentValue =
    value &&
    (isDate(value)
      ? value.toLocaleDateString()
      : `${value.from.toLocaleDateString()} - ${value.to.toLocaleDateString()}`);

  return (
    <div className="DayPickerContainer" ref={containerRef}>
      <div
        className={classNames('DayPickerContainer__wrapper', {
          'DayPickerContainer__wrapper--disabled': disabled,
        })}
        onClick={handleOpenClick}
      >
        <ReactSVG src={DatePickerIcon} className="DayPickerContainer__icon" />
        <p className="dropDownUser__trigger-name">
          {currentValue || placeholder || 'Select date'}
        </p>
        <ReactSVG
          src={ArrowIcon}
          className={classNames('DayPickerContainer__close-button', {
            'DayPickerContainer__close-button--open': isOpen,
          })}
        />
      </div>
      <div
        className={classNames('DayPickerContainer-Overlay', {
          'DayPickerContainer-Overlay--left': position === 'left',
          'DayPickerContainer-Overlay--right': position === 'right',
        })}
      >
        {isOpen && <Calendar value={value} onHide={close} {...restProps} />}
      </div>
    </div>
  );
};

export default UIDatePicker;
